import { Percent } from '@uniswap/sdk-core';
var FIVE_TENTHS_PERCENT = new Percent(50, 10000); // .50%
export var DEFAULT_AUTO_SLIPPAGE = FIVE_TENTHS_PERCENT;
export function toPercent(maxSlippage) {
    var numerator = Math.floor(maxSlippage * 100);
    return new Percent(numerator, 10000);
}
export var DEFAULT_SLIPPAGE = { auto: true, allowed: DEFAULT_AUTO_SLIPPAGE };
/** Returns the allowed slippage, and whether it is auto-slippage. */
export default function getSlippage(maxSlippage) {
    if (!maxSlippage)
        return DEFAULT_SLIPPAGE;
    if (maxSlippage > 100)
        return { auto: true, allowed: toPercent(100) };
    if (maxSlippage < 0)
        return { auto: true, allowed: toPercent(0) };
    return { auto: true, allowed: toPercent(maxSlippage) };
    // let shouldUseAutoSlippage: boolean = false;
    // selectAtom(autoSlippageAtom, (atomValue) => {
    //   shouldUseAutoSlippage = atomValue.valueOf()
    // })
    // const autoSlippage = useAutoSlippageTolerance(shouldUseAutoSlippage ? trade : undefined)
    // const maxSlippageValue = useAtomValue(maxSlippageAtom)
    // const maxSlippage = useMemo(() => toPercent(maxSlippageValue), [maxSlippageValue])
    // return useMemo(() => {
    //   const auto = shouldUseAutoSlippage || !maxSlippage
    //   const allowed = shouldUseAutoSlippage ? autoSlippage : maxSlippage ?? autoSlippage
    //   const warning = auto ? undefined : getSlippageWarning(allowed)
    //   if (auto && allowed === DEFAULT_AUTO_SLIPPAGE) {
    //     return DEFAULT_SLIPPAGE
    //   }
    //   return { auto, allowed, warning }
    // }, [autoSlippage, maxSlippage, shouldUseAutoSlippage])
}
export var MAX_VALID_SLIPPAGE = new Percent(1, 2);
export var MIN_HIGH_SLIPPAGE = new Percent(1, 100);
export function getSlippageWarning(slippage) {
    if (slippage === null || slippage === void 0 ? void 0 : slippage.greaterThan(MAX_VALID_SLIPPAGE))
        return 'error';
    if (slippage === null || slippage === void 0 ? void 0 : slippage.greaterThan(MIN_HIGH_SLIPPAGE))
        return 'warning';
    return;
}
